export const hashtag = () => (
  <path
    d="M4 9h16M4 15h16M10 3L8 21m8-18l-2 18"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
